import { combineReducers } from "redux"
import { chain, camelCase } from "lodash"

const reducers = chain(require.context(".", true, /^\.\/[^/]+\/model\.[jt]sx?$/).keys())
  .map(path => path.split("/")[1])
  .map(id => [camelCase(id), require(`./${id}/model`).default])
  .fromPairs()
  .omitBy(reducer => !reducer)
  .value()

export default combineReducers(reducers)
